import {PIXI} from '@colonist/pixi'
import {UIGameMapController} from './UIGameMapController'

export class UIGameMapBottomLogo {
    private readonly logo: PIXI.Sprite

    constructor(mapController: UIGameMapController, logoTexture: PIXI.Texture) {
        const logoHeight = mapController.mapView.hexagonHeight * 0.6
        const logoWidth = logoHeight * logoTexture.width / logoTexture.height

        const mapTileViewYs = mapController.tileViews.map((tileView) => tileView.y)
        const maxMapTileViewY = Math.max(...mapTileViewYs)

        const mapTileViewXs = mapController.tileViews.map((tileView) => tileView.x)
        const minMapTileViewX = Math.min(...mapTileViewXs)
        const maxMapTileViewX = Math.max(...mapTileViewXs)

        const logoY = maxMapTileViewY + mapController.mapView.hexagonHeight * 1.275
        const logoX = (minMapTileViewX + maxMapTileViewX) / 2 + mapController.mapView.hexagonWidth / 2

        this.logo = new PIXI.Sprite(logoTexture)
        this.logo.anchor.set(0.5, 0)
        this.logo.position.set(logoX, logoY)

        this.logo.width = logoWidth
        this.logo.height = logoHeight
        mapController.mapView.addChild(this.logo)
    }
}
